import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  DateTimePicker,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
  InlineEditableTable,
} from '../components';
import Apis from '../apis';
import { ErrorDispatches } from '../redux/Dispatches';
import { Nullable } from '../types';
import { PHIWH, StudentPHIWH } from '../model';
import { Row, Button, Col } from 'react-bootstrap';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { ClassSem, WrapClassBaseLayout } from '../layouts';
import { ApplicationState } from '../redux/States';
import { WHTableHeader } from './TableHeaders/WHHeader';

type MetricPageData = StudentPHIWH & Nullable<PHIWH>;

const displayHeader: HeaderDisplayKeysWithType<MetricPageData>[] = [
  { property: 'seat', display: '座號' },
  { property: 'name', display: '學生' },
  ...(WHTableHeader as HeaderDisplayKeysWithType<MetricPageData>[]),
];

const modalDisplayHeader: HeaderDisplayKeysWithType<PHIWH>[] = [
  { property: 'year', display: '學年' },
  { property: 'sem', display: '學期' },
  ...WHTableHeader,
];

const mapState = (state: ApplicationState, ownProps: ClassSem) => ({
  ...ownProps,
  ...state.auth,
});
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;
const classPHIWHPage: FunctionComponent<Props> = ({
  classId,
  year,
  sem,
  catchErrorForModal,
}) => {
  const [students, setStudent] = useState([] as MetricPageData[]);
  // const [inputing, setInputing] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [editingStudent, setEditingStudent] = useState<MetricPageData>();
  const [wHExamDate, setWHExamDate] = useState<DateTime>();
  const [initialExamDate, setInitialExamDate] = useState<DateTime>();
  const [newExamDate, setNewExamDate] = useState<DateTime>();

  useEffect(() => {
    refreshStudentMetric();
  }, [classId, year, sem, toggle]);

  function refreshStudentMetric() {
    if (classId && year && sem) {
      Apis.getClassStudentMetric(classId, year, sem)
        .then((metrics) => {
          const datas: MetricPageData[] = metrics.map((m) => {
            const latestMetric =
              m.phiWHs.length > 0
                ? m.phiWHs.find((cv) => cv.year === year && cv.sem === sem)
                : undefined;
            if (latestMetric?.height === 0 || latestMetric?.weight === 0) {
              latestMetric.height = null;
              latestMetric.weight = null;
              latestMetric.bmi = null;
              latestMetric.bmiCode = null;
            }
            return {
              year,
              sem,
              ...m,
              ...latestMetric,
            };
          });
          setStudent(datas);
        })
        .catch(catchErrorForModal);
    } else {
      setStudent([]);
    }
  }

  function onHide(metric: MetricPageData) {
    console.log('onHide', metric, editingStudent);
    if (editingStudent && editingStudent.pid === metric.pid) {
      setEditingStudent(undefined);
    }
  }
  console.log('outside editingStudent', editingStudent);
  function onEditMetric(metric: MetricPageData) {
    setEditingStudent(metric);
    console.log('editingStudent', metric);
  }

  function onDelete(sight: MetricPageData) {
    toast
      .promise(Apis.deleteStudentWH(sight.pid, year, sem), {
        pending: '資料刪除中......',
        success: '資料刪除成功！',
        error: '資料刪除失敗！請查看錯誤資訊。',
      })
      .then(() => setToggle(!toggle))
      .catch(catchErrorForModal);
  }

  async function onUpdateStudentMetric(metric: PHIWH) {
    if (editingStudent && editingStudent.pid) {
      toast.dismiss();
      toast
        .promise(Apis.InsertStudentBodyMetrix(editingStudent?.pid, metric), {
          pending: '資料上傳中......',
          success: '上傳成功！',
          error: '上傳失敗！請查看錯誤資訊。',
        })
        .then(() => {
          setToggle(!toggle);
        })
        .catch(catchErrorForModal);
    }
  }

  function updateWHExamDate() {
    if (classId && wHExamDate) {
      Apis.UpdateWHExamDate(classId, year, sem, wHExamDate, wHExamDate)
        .then((count) => {
          toast.success(`資料更新成功！共 ${count} 筆資料已更新。`);
          setToggle(!toggle);
        })
        .catch(catchErrorForModal);
    }
  }

  function updateSelectedWHExamDate() {
    if (classId && initialExamDate && newExamDate) {
      Apis.UpdateSelectedWHExamDate(
        classId,
        year,
        sem,
        initialExamDate,
        newExamDate
      )
        .then((count) => {
          toast.success(`資料更新成功！共 ${count} 筆資料已更新。`);
          setToggle(!toggle);
        })
        .catch(catchErrorForModal);
    }
  }
  return (
    <React.Fragment>
      {students.length ? (
        <>
          <Row className="mb-3">
            體位測量日設定：
            <Col sm={2} className="mr-3">
              <DateTimePicker
                containerClass="wid-140 mr-2"
                value={wHExamDate}
                onChange={(date) => {
                  setWHExamDate(date);
                }}
              />
            </Col>
            <Button
              disabled={wHExamDate ? false : true}
              onClick={updateWHExamDate}
            >
              設定測量日
            </Button>
          </Row>
          <hr />
          <Row className="mb-3">
            <Col sm={12}>體位測量日修改</Col>
            請輸入原設定日期：
            <Col sm={2} className="mr-2">
              <DateTimePicker
                containerClass="wid-140 mr-2"
                value={initialExamDate}
                onChange={(date) => {
                  setInitialExamDate(date);
                }}
              />
            </Col>
            請輸入欲修改日期：
            <Col sm={2} className="mr-3">
              <DateTimePicker
                containerClass="wid-140 mr-2"
                value={newExamDate}
                onChange={(date) => {
                  setNewExamDate(date);
                }}
              />
            </Col>
            <Button
              disabled={initialExamDate ? (newExamDate ? false : true) : true}
              onClick={updateSelectedWHExamDate}
            >
              更新測量日
            </Button>
          </Row>
          <hr />
        </>
      ) : (
        <></>
      )}
      <Row>
        <div
          className="mt-3 p-3"
          style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            fontSize: '15px',
            lineHeight: '1.6',
            width: '100%',
            marginBottom: '10px',
          }}
        >
          <div>
            <strong>身高體重輸入說明：</strong>
          </div>
          <div>無法測量時，請輸入-9(無須輸入測量日)</div>
        </div>
      </Row>
      <Row className="align-items-start">
        <Col
          sm={8}
          style={{
            minWidth: 0,
          }}
        >
          <div
            style={{
              width: '100%',
              overflowX: 'auto',
            }}
          >
            <InlineEditableTable
              responsive
              values={students}
              fixCol={2}
              headers={displayHeader}
              autoNext={true}
              onValueUpdate={(value) => {
                const isUnexamined =
                  Number(value.height) === -9 ||
                  Number(value.weight) === -9;

                if (!isUnexamined && !value.examDate) {
                  toast.error('請填入測量日');
                  return;
                }

                if (isUnexamined && !value.examination) {
                  toast.error('請選擇未受檢原因');
                  return;
                }

                const data: PHIWH = {
                  id: 0,
                  sem,
                  year,
                  height: value.height,
                  weight: value.weight,
                  examDate: isUnexamined
                    ? null
                    : value.examDate,
                  yearClassId: 0,
                  examination: isUnexamined
                    ? value.examination
                    : null,
                  examinationState: isUnexamined
                    ? value.examinationState
                    : null,
                };

                onUpdateStudentMetric(data);
              }}
              onValueDelete={onDelete}
              onRowUpdating={onEditMetric}
              onRowCancelUpdate={onHide}
              onRowRender={() => ({
                deleteable: true,
                editable: true,
              })}
            />
          </div>
        </Col>

        <Col
          sm={4}
          style={{
            minWidth: 0,
          }}
        >
          <div
            style={{
              width: '100%',
              overflowX: 'auto',
            }}
          >
            <EditableTableDiv
              nonScrollable
              fixCol={2}
              values={editingStudent?.phiWHs || []}
              headers={modalDisplayHeader}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export const ClassPHIWHPage = connector(WrapClassBaseLayout(classPHIWHPage));
